import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';

import { useGetAnimalTraitsMessages } from './messages';

export function getAnimalTraitsCacheKey(
  organisationId?: number,
  animalId?: number,
) {
  return `/api/AnimalTrait?organisationId=${organisationId}&animalId=${animalId}`;
}

export interface useGetAnimalTraitsOptions {
  shouldFetch?: boolean;
}

export function useGetAnimalTraits(
  organisationId?: number,
  animalId?: number,
  options?: useGetAnimalTraitsOptions,
) {
  const mergedOptions: useGetAnimalTraitsOptions = {
    shouldFetch: true,
    ...options,
  };

  const { animalDetailApi } = usePrivate();

  const results = useSWR(
    animalDetailApi && mergedOptions.shouldFetch
      ? getAnimalTraitsCacheKey(organisationId, animalId)
      : null,
    () => animalDetailApi?.apiEntityDetailGet(organisationId, animalId),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetAnimalTraitsMessages[
            'useGetAnimalTraits.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetAnimalDetail> error fetching organisations.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !animalDetailApi;

  return { ...results, isLoadingOrValidating };
}
